export default [
  {
    path: '/app-manage',
    name: 'AppManage',
    component: () => import('@/layouts/main.vue'),
    redirect: '/app-update-config',
    children: [
      {
        path: 'app-manage/list',
        name: 'ApplicationManage',
        component: () => import('@/views/app/app-manage/list.vue'),
        meta: {
          title: '应用管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'dev-account-manage/list',
        name: 'DevAccountManage',
        component: () => import('@/views/app/dev-account-manage/list.vue'),
        meta: {
          title: '开发者账号管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'dev-user-manage/list',
        name: 'DevUserManage',
        component: () => import('@/views/app/dev-user-manage/list.vue'),
        meta: {
          title: '开发者用户管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'notification-manage/list',
        name: 'NotificationManage',
        component: () => import('@/views/app/notification-manage/list.vue'),
        meta: {
          title: '通知配置管理',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'app-update-record',
        name: 'AppUpdateRecord',
        component: () => import('@/views/app/app-update-record/index.vue'),
        meta: {
          title: '版本更新记录',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'seller-app-update-config',
        name: 'SellerAppSettingUpdate',
        component: () => import('@/views/app/app-update-config/seller.vue'),
        meta: {
          title: '版本更新配置',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'app-update-config',
        name: 'AppSettingUpdate',
        component: () => import('@/views/app/app-update-config/index.vue'),
        meta: {
          title: '应用更新配置',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
